export default __webpack_public_path__ + "static/logo-1ac900efcd2d1c3b83a45b29bd88828c.svg";